module.exports = __webpack_public_path__ + "img/privacy_important.6e7c1c73.svg";